export default "__VITE_ASSET__C$5MwuoO__"